import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button } from '@mssgme/ui';
import styles from './styles.scss';

export default function AccountBlocked({ isBlockedByIp }) {
    const { t, i18n } = useTranslation();
    const helpUrl = i18n.language === 'ru' ? 'https://mssg.me/help' : 'https://mssg.me/mssgmeen';

    return (
        <div className={styles.root}>
            {isBlockedByIp ? (
                <>
                    <h1>{t('AccountBlocked.ip')}</h1>
                </>
            ) : (
                <>
                    <h1>{t('AccountBlocked.heading')}</h1>
                </>
            )}
            <p>{t('AccountBlocked.description')}</p>
            <p>
                <Button tag="a" href={helpUrl}>
                    {t('AccountBlocked.button')}
                </Button>
            </p>
        </div>
    );
}

AccountBlocked.defaultProps = {
    isBlockedByIp: false,
};

AccountBlocked.propTypes = {
    isBlockedByIp: PropTypes.bool,
};
